let visibleItem = 3;
let isLastElm = false;

let slice = function (elements, start, end) {
  let sliced = Array.prototype.slice.call(elements, start, end);
  return sliced;
};

if (document.querySelectorAll(".team-member").length <= 3) {
  document.querySelector(".show-more-btn").style.display = "none";
}

let firstVisibleElements = slice(
  document.querySelectorAll(".team-member"),
  0,
  3,
);

firstVisibleElements.forEach((i) => i.classList.add("show"));

document
  .getElementsByClassName("show-more-btn")[0]
  .addEventListener("click", (ev) => {
    ev.preventDefault();
    visibleItem = visibleItem + 3;
    let sliced = slice(
      document.querySelectorAll(".team-member"),
      0,
      visibleItem,
    );
    sliced.forEach((i) => i.classList.add("show"));

    if (visibleItem >= document.querySelectorAll(".team-member").length) {
      document.querySelector(".show-more-btn").style.display = "none";
    }
  });
